module.exports = __webpack_public_path__ + "img/TZS09671.db80e7f0.jpeg";